import request from '@/utils/request'
import { fileService } from "@/api/common/file-utils";
export default {
    findListPage: (data) => {
        return request({
            url: '/nutrInspectWindow/findListPage',
            method: 'post',
            data: data
        })
    },
    dictQueryPage: (data) => {
        return request({
            url: '/dict-config/query-page',
            method: 'post',
            data: data
        })
    },
    findDeliveryListPage: (data) => {
        return request({
            url: '/nutrDeliveryRatio/findDeliveryListPage',
            method: 'post',
            data: data
        })
    },
    findIngredientListPage: (data) => {
        return request({
            url: '/nutrition/ingredient/query-list',
            method: 'post',
            data: data
        })
    },
    findDeliveryRatioListPage: (data) => {
        return request({
            url: '/nutrDeliveryRatio/findDeliveryRatioListPage',
            method: 'post',
            data: data
        })
    },
    // nutrition检测分析查询接口
    findAnalysisPage: (data) => {
        return request({
            url: '/nutrReport/findListPage',
            method: 'post',
            data: data
        })
    },
    // nutrition检测分析展开行接口
    getReportFacilityDetailListByReportId: (data) => {
        return request({
            url: '/nutrReport/getReportFacilityDetailListByReportId',
            method: 'post',
            data: data
        })
    },
    // 检测模板查询列表
    findTemplateQuery: (data) => {
        return request({
            url: `/nutrition/template/query-list`,
            method: 'post',
            data: data
        })
    },
    // nutrition检测查询列表
    findNutritionQuery: (data) => {
        return request({
            url: `/inspect/query-page`,
            method: 'post',
            data: data
        })
    },
    // 获取新增Ingredient主数据信息
    findNutritionAddQuery: (data) => {
        return request({
            url: `/inspect/query-add-list`,
            method: 'post',
            data: data
        })
    },
    // 定版
    confirmEdition: (data) => {
        return request({
            url: `/nutrReport/confirmEdition`,
            method: 'post',
            data: data
        })
    },
    // 发布
    nutrReportRelease: (data) => {
        return request({
            url: `/nutrReport/release`,
            method: 'post',
            data: data
        })
    },
    // 父列表波动原因修改
    remarkReportGapReason: (data) => {
        return request({
            url: `/nutrReport/remarkReportGapReason`,
            method: 'post',
            data: data
        })
    },
    // 子列表波动原因修改
    remarkInspectGapReason: (data) => {
        return request({
            url: `/nutrReport/remarkReportFacilityGapReason`,
            method: 'post',
            data: data
        })
    },
    // 检测原因维护
    editInspectReason: (data) => {
        return request({
            url: `/inspect/edit-inspect-reason`,
            method: 'post',
            data: data
        })
    },
    inspectDelete: (data) => {
        return request({
            url: '/inspect/delete',
            method: 'post',
            data: data
        })
    },
    inspectRestore: (data) => {
        return request({
            url: '/inspect/restore',
            method: 'post',
            data: data
        })
    },
    inspectConfirm: (data) => {
        return request({
            url: '/inspect/confirm',
            method: 'post',
            data: data
        })
    },
    inspectRelease: () => {
        return request({
            url: '/inspect/release',
            method: 'get',
        })
    },
    inspectSubmit: (data) => {
        return request({
            url: '/inspect/submit-detail',
            method: 'post',
            data: data
        })
    },
    inspectSave: (data) => {
        return request({
            url: '/inspect/edit-detail',
            method: 'post',
            data: data
        })
    },
    editComment: (data) => {
        return request({
            url: '/nutrition/template/edit-comments',
            method: 'post',
            data: data
        })
    },
    queryInspectSubmit: (data) => {
        return request({
            url: '/inspect/submit',
            method: 'post',
            data: data
        })
    },
    saveInspectFlag: (data) => {
        return request({
            url: '/nutrition/ingredient/inspect-flag',
            method: 'post',
            data: data
        })
    },
    saveInspectAdd: (data) => {
        return request({
            url: '/inspect/add',
            method: 'post',
            data: data
        })
    },
    saveCopy: (data) => {
        return request({
            url: '/inspect/copy-inspect',
            method: 'post',
            data: data
        })
    },
    getCopyList: (inspectId) => {
        return request({
            url: `/inspect/get-copy-list/${inspectId}`,
            method: 'get',
        })
    },
    getModuleList: () => {
        return request({
            url: `/dict-config/module-list`,
            method: 'get',
        })
    },
    getDictTypeList: (module) => {
        return request({
            url: `/dict-config/type-list?module=${module}`,
            method: 'get',
        })
    },
    getNutritionDetail: (inspectId, displayInspectWindowAndVersionFlag) => {
        return request({
            url: `/inspect/${inspectId}/${displayInspectWindowAndVersionFlag}`,
            method: 'get',
        })
    },
    getWindowTimeList: () => {
        return request({
            url: `/nutrInspectWindow/getWindowTimeList`,
            method: 'get',
        })
    },
    getStatusLists: () => {
        return request({
            url: `/nutrition/template/status-list`,
            method: 'get',
        })
    },
    getTestLists: (templateId) => {
        return request({
            url: `/nutrition/template/detail/${templateId}`,
            method: 'get',
        })
    },
    saveTest: (data, templateId) => {
        return request({
            url: `/nutrition/template/${templateId}/edit`,
            method: 'post',
            data: data
        })
    },
    getFileLists: (templateId) => {
        return request({
            url: `/nutrition/template/file-list/${templateId}`,
            method: 'get',
        })
    },
    delTemplateItem: (templateId) => {
        return request({
            url: `/nutrition/template/delete/${templateId}`,
            method: 'get',
        })
    },
    saveFile: (data, templateId) => {
        return request({
            url: `/nutrition/template/save-batch-file/${templateId}`,
            method: 'post',
            data: data
        })
    },
    copyTemplate: (templateId) => {
        return request({
            url: `/nutrition/template/copy/${templateId}`,
            method: 'get',
        })
    },
    saveInspectWindow: (data) => {
        return request({
            url: `/nutrInspectWindow/saveInspectWindow`,
            method: 'post',
            data: data
        })
    },
    saveDictAdd: (data) => {
        return request({
            url: `/dict-config/edit`,
            method: 'post',
            data: data
        })
    },
    saveLab: (data) => {
        return request({
            url: `/nutrition/ingredient/config-laboratory`,
            method: 'post',
            data: data
        })
    },
    saveNote: (param) => {
        return request({
            url: `/nutrition/ingredient/comments`,
            method: 'post',
            data: param
        })
    },
    deleteInspectWindow: (data, id) => {
        return request({
            url: `/nutrInspectWindow/deleteInspectWindow/${id}`,
            method: 'post',
            data: data
        })
    },
    getInspectWindow: (id) => {
        return request({
            url: `/nutrInspectWindow/getInspectWindow/${id}`,
            method: 'get',
        })
    },
    startTask: (data, id) => {
        return request({
            url: `/nutrInspectWindow/startTask/${id}`,
            method: 'post',
            data: data
        })
    },
    //文件上传
    fileUpload: (data) => {
        return request({
            url: "/file",
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
            },
            data: data,
        });
    },
    // 导入模板下载
    downloadImportTemplate: () => request({
        url: '/inspect/download-import-template',
        method: 'get',
        fullResponse: true,
        responseType: 'blob',
    }).then(resp => {
        fileService.respToFile(resp, '营养检测数据批量导入.xlsx');
    }),
    //导入营养检测数据
    fileUploadExcel: (data) => {
        return request({
            url: "/inspect/excel/import",
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
            },
            data: data,
        });
    },
    // 附件命名模板下载
    downloadAttachmentTemplate: () => request({
        url: '/inspect/download-attachment-template',
        method: 'get',
        fullResponse: true,
        responseType: 'blob',
    }).then(resp => {
        fileService.respToFile(resp, '营养数据附件命名模板.xlsx');
    }),
    // 导入营养检测附件
    fileUploadZip: (data) => {
        return request({
            url: "/inspect/zip/import",
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data; charset=UTF-8",
            },
            data: data,
        });
    },
    // 报表导出
    downloadQueryLists: (param) => request({
        url: '/inspect/export-excel',
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: param
    }).then(resp => {
        fileService.respToFile(resp, 'Nutrition检测下载.xlsx');
    }),
    // ingredient下载
    downloadIngredientLists: (param) => request({
        url: '/nutrition/ingredient/export',
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: param
    }).then(resp => {
        fileService.respToFile(resp, 'Ingredient主数据下载.xlsx');
    }),
    deliveryDataListDownload: (param) => request({
        url: '/nutrDeliveryRatio/deliveryDataListDownload',
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: param
    }).then(resp => {
        fileService.respToFile(resp, '发货数据报表.xlsx');
    }),
    deliveryRatioDataListDownload: (param) => request({
        url: '/nutrDeliveryRatio/deliveryRatioDataListDownload',
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: param
    }).then(resp => {
        fileService.respToFile(resp, '供货比重报表.xlsx');
    }),
    // nutrition分析导出接口
    reportListDownload: (param) => request({
        url: '/nutrReport/reportListDownload',
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: param
    }).then(resp => {
        fileService.respToFile(resp, 'Nutrition_GRI_Analysis报表.xlsx');
    }),
    resolvePath: () => {
        return request({
            url: '/menuNutritionAnalysis',
            method: 'get',
        })
    },
    updateDeliveryRatio: (data) => {
        return request({
            url: `/nutrDeliveryRatio/updateDeliveryRatio`,
            method: 'post',
            data: data
        })
    },
}